import { c as _c } from "react/compiler-runtime";
interface SearchIconProps {
  className?: string;
}
export const SearchIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M16.2408 14.8913C18.7728 11.3416 18.4611 6.35591 15.3056 3.15982C11.8042 -0.386606 6.1274 -0.386606 2.62603 3.15982C-0.875343 6.70624 -0.875343 12.4561 2.62603 16.0026C5.91872 19.3376 11.1353 19.5364 14.6573 16.5989L22.3654 24.5034L24 22.8477L16.2408 14.8913ZM13.671 4.8155C16.2696 7.44751 16.2695 11.7149 13.671 14.3469C11.0724 16.9789 6.85926 16.9789 4.26068 14.3469C1.6621 11.7149 1.6621 7.44752 4.26068 4.8155C6.85926 2.18349 11.0724 2.18348 13.671 4.8155Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};